import "@hotwired/turbo-rails";
import { Application } from "@hotwired/stimulus";
import Notification from "@stimulus-components/notification";
import "@github/markdown-toolbar-element";
import { DirectUpload } from "@rails/activestorage";
import { post } from "@rails/request.js";
import { subscribe } from "@github/paste-markdown";
import { MarksmithController } from "@avo-hq/marksmith/core";

// import {
//   MarksmithController,
//   ListContinuationController,
// } from "@avo-hq/marksmith";
import { registerControllers } from "stimulus-vite-helpers";

const application = Application.start();

application.debug = process.env.NODE_ENV === "development";
application.warnings = true;
window.Stimulus = application;

// Registering controllers
application.register("notification", Notification);
application.register("marksmith", MarksmithController);
// application.register("list-continuation", ListContinuationController);

try {
  const controllers = import.meta.glob("~/controllers/**/*_controller.js", {
    eager: true,
  });
  registerControllers(application, controllers);
} catch (error) {
  console.error("Error registering Stimulus controllers:", error);
}

// // Setting the timezone before stimulus is loaded
// setTimezoneCookie("timezone", Intl.DateTimeFormat().resolvedOptions().timeZone)
// function setTimezoneCookie (name, value) {
//   const expires = new Date()
//   expires.setTime(expires.getTime() + 24 * 60 * 60 * 1000)
//   document.cookie = `${name}=${value};expires=${expires.toUTCString()};SameSite=Lax`
// }
